import React, {useState} from 'react';
import Typography from "@material-ui/core/Typography";
import {Button, Grid, TextField} from "@material-ui/core";
import WhiteHeaderCard from "../../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../colors";
import PropTypes from "prop-types";
import * as actions from "../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {emailRegex, getImeiListFromDevices} from "../../../../utils/utils";
import DefaultSelect from "../../../../../components/ui/inputs/selects/default-select/DefaultSelect";
import RichiestaInviataDialog from "../../richiesta-inviata-dialog/RichiestaInviataDialog";
import ButtonWithProgress from "../../../../../components/ui/buttons/button-with-progress/ButtonWithProgress";

const useStyles = makeStyles({
    cardContent: {
        color: colors.font.light,
    },
    inputFieldStyle: {
        width: "95%"
    },
    multiLineTextFieldLabel: {
        marginTop: "-15px"
    },
    multiLineLabelTextField: {
        marginTop: "18px"
    },
    gridCenteredInputs: {
        alignSelf: "center"
    }
});

const FurtoOSmarrimentoDialog = (props) => {
    const classes = useStyles();

    const [furtoOSmarrimento, setFurtoOSmarrimento] = useState("Furto");
    const [ritiroTerminale, setRitiroTerminale] = useState("");
    const [mailDiContatto, setMailDiContatto] = useState("");
    const [firstTimeEmail, setFirstTimeEmail] = useState(0);
    const [numeroTelefonicoDiContatto, setNumeroTelefonicoDiContatto] = useState("");
    const [openRichiestaInviata, setOpenRichiestaInviata] = useState(false);
    const [firstTimeTelephone, setFirstTimeTelephone] = useState(0);

    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId);
    const userId = useSelector(state => state.authReducer.userClaims.uid);
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const dispatch = useDispatch();

    const problemaSelectItems = [
        {value: "Furto", text: "Furto"},
        {value: "divider", text: "divider"},
        {value: "Smarrimento", text: "Smarrimento"}
    ];

    const handleRichiestaInviataButton = () => {
        setOpenRichiestaInviata(false);
        props.closeAssistenza();
    }

    const disableButton = () => {
        return ritiroTerminale.length === 0 ||
            numeroTelefonicoDiContatto.length === 0 ||
            furtoOSmarrimento.length === 0 ||
            !emailRegex.test(String(mailDiContatto.toLowerCase()));
    }

    const handleFurtoOSmarrimentoChange = (event) => {
        setFurtoOSmarrimento(event.target.value);
    }

    const handleRitiroTerminaleChange = (event) => {
        setRitiroTerminale(event.target.value);
    }

    const handleMailDiContattoChange = (event) => {
        setMailDiContatto(event.target.value);
        setFirstTimeEmail(1);
    }

    const handleNumeroTelefonicoDiContattoChange = (event) => {
        setNumeroTelefonicoDiContatto(event.target.value);
        setFirstTimeTelephone(1);
    }

    const handleContattaciClick = () => {
        const imeiList = getImeiListFromDevices(props.selectedDevices);
        dispatch(actions.sendVpServiceRequest(imeiList, furtoOSmarrimento, ritiroTerminale, mailDiContatto,
            numeroTelefonicoDiContatto, integrationId, userId));
        setOpenRichiestaInviata(true);
    }

    return (
        <React.Fragment>
            <WhiteHeaderCard title={"Furto o smarrimento"}>
                <div>
                    <Typography variant="body2" className={classes.cardContent}>
                        In caso di furto o smarrimento del tuo terminale non esitare a contattarci.
                    </Typography>
                    <Typography variant="body2" className={classes.cardContent}>
                        Bastano poche informazioni per procedere con la richiesta.
                    </Typography>
                </div>
                <Grid container className="mt-12">
                    <Grid item xs={12} md={2} className="mt-24">
                        <Typography variant="subtitle2">
                            Problema
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10} className={classes.gridCenteredInputs}>
                        <DefaultSelect
                            menuItems={problemaSelectItems}
                            hasEmptyItem={false}
                            handleOnChange={(event) => handleFurtoOSmarrimentoChange(event)}
                            formControlStyle={classes.inputFieldStyle}
                            value={furtoOSmarrimento}
                        />
                    </Grid>
                    <Grid item xs={12} md={2} className="mt-24">
                        <Typography variant="subtitle2">
                            Indirizzo completo di ritiro terminale
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10} className={classes.gridCenteredInputs}>
                        <TextField
                            id={"input-terminale"}
                            className={classes.inputFieldStyle}
                            onChange={(event) => handleRitiroTerminaleChange(event)}
                            placeholder={"Da compilare solo in caso il terminale abbia l’assistenza Kasko Premium o Custom"}
                            value={ritiroTerminale}
                            type={"text"}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} md={2} className="mt-24">
                        <Typography variant="subtitle2">
                            Mail di contatto
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10} className={classes.gridCenteredInputs}>
                        <TextField
                            id={"input-email"}
                            className={classes.inputFieldStyle}
                            onChange={(event) => handleMailDiContattoChange(event)}
                            placeholder={"Inserisci la mail per il contatto"}
                            value={mailDiContatto}
                            required
                            error={!emailRegex.test(String(mailDiContatto.toLowerCase())) && firstTimeEmail !== 0}
                            helperText={firstTimeEmail !== 0 && !emailRegex.test(String(mailDiContatto.toLowerCase())) ?
                                "Email non valida" : null}
                            type={"email"}
                        />
                    </Grid>
                </Grid>
                <Grid container className={"mb-24"}>
                    <Grid item xs={12} md={2} className={classes.gridCenteredInputs + " mt-24"}>
                        <Typography variant="subtitle2">
                            Numero telefonico di contatto
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10} className={classes.gridCenteredInputs}>
                        <TextField
                            id={"input-telephone"}
                            className={classes.inputFieldStyle}
                            onChange={(event) =>
                                handleNumeroTelefonicoDiContattoChange(event)}
                            placeholder={"Inserisci il numero di telefono"}
                            value={numeroTelefonicoDiContatto}
                            required
                            error={numeroTelefonicoDiContatto.length === 0 && firstTimeTelephone !== 0}
                            helperText={firstTimeTelephone !== 0 && numeroTelefonicoDiContatto.length === 0 ?
                                "Telefono non valido" : null}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E'
                                    || evt.key === '-' || evt.key === '.')
                                && evt.preventDefault()}
                            type={"number"}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <ButtonWithProgress
                        text={"Contattaci"}
                        handleClick={handleContattaciClick}
                        disabled={disableButton()}
                        loading={loadingReportProblem}
                        variant={'outlined'}
                    />
                    <Button onClick={props.returnToMenu}
                            color="primary"
                            variant="text">
                        Indietro
                    </Button>
                </Grid>
            </WhiteHeaderCard>
            {openRichiestaInviata && !loadingReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichiestaInviata}
                    handleDialogClose={handleRichiestaInviataButton}
                    titleText={!errorReportProblem ? "Richiesta inviata" : "Richiesta non inviata"}
                    bodyText={!errorReportProblem ?
                        "Gentile cliente, la tua richiesta è stato presa in carico…entro poche ore potrai consultare lo stato della pratica nell’area richieste assistenza" :
                        "Gentile cliente c’è stato un problema nell’apertura della richiesta. Riprova più tardi oppure contattaci con le modalità indicate nell’area Richieste e Assistenza del portale"
                    }
                    handleRichiestaCloseButton={errorReportProblem ? () => setOpenRichiestaInviata(false) :
                        handleRichiestaInviataButton}
                />
            ) : null}
        </React.Fragment>
    )
}

FurtoOSmarrimentoDialog.propTypes = {
    returnToMenu: PropTypes.func,
    closeAssistenza: PropTypes.func,
    selectedDevices: PropTypes.array
}


export default FurtoOSmarrimentoDialog;
